import React from 'react'
import { useState, useEffect } from "react"
import * as toastr from "toastr"

import Loader from "Placements/Components/Loader"
import API from "Placements/API"

type hashObject = {
    hash: string
    id_Usuario: string
}

const Formulario = ({ props }: any) => {

    const [password, setPassword] = useState("")
    const [passwordConfirm, setPasswordConfirm] = useState("")
    const [isLoading, setLoading] = useState(true)
    const params: hashObject = props.match.params;

    useEffect(() => {
        if (params.hash == null || params.id_Usuario == null) {
            toastr.error('Erro', '');
            window.location.href = "#/login"
            return;
        }
        //http://localhost:8081/#/redefine-senha/21436688/7682
        //api get link já utilizado?
        API.Auth.VerifyHash({ hash: params.hash, idUsuario: params.id_Usuario })
            .then((response: any) => {
                if (!response.data) {
                    toastr.error('Requisição já utilizada. Realize uma nova requisição de alteração de senha!', '');
                    window.location.href = "#/login"
                }
            }).catch((error: any) => {
                toastr.error('Requisição já utilizada. Realize uma nova requisição de alteração de senha!', '');
                window.location.href = "#/login"
            }).finally(() => {
                setLoading(false)
            })
    }, [])

    const handleReset = async (e: any) => {
        e.preventDefault();
        setLoading(true)

        try {
            if (password == "" || passwordConfirm == "") {
                throw ("Por favor digite as senhas!")
            } else if (password !== passwordConfirm) {
                throw ("Senhas não coincidem, digite novamente.")
            }

            const responseAuth = await API.Auth.UpdatePassword({ hash: params.hash, Id_Usuario: params.id_Usuario, Senha: password })
            const { data } = responseAuth
            if (data) {
                toastr.success('Senha cadastrada com sucesso.', '')
                window.location.href = "#/login"
            } else {
                toastr.error("Alguma coisa deu errado!", "Senha não cadastrada")
            }
        } catch (erro) {
            toastr.error(erro, "Error!")
        } finally {
            setLoading(false)
        }
    }


    return (
        <div className="form-login">
            {isLoading && <Loader />}
            <div>
                <h3 className="form-title">Bem-vindo, cidadão do mundo!</h3>
                <p className="form-txt">Faça o teste online e descubra o seu nível de inglês e/ou espanhol.</p>

                <form onSubmit={handleReset} >
                    <input
                        id="password"
                        name="password"
                        type="password"
                        className="form-input"
                        placeholder="Senha"
                        onChange={(e: any) => setPasswordConfirm(e.target.value)}
                    />
                    <input
                        id="passwordConfirm"
                        name="passwordConfirm"
                        type="password"
                        className="form-input"
                        placeholder="Confirmar senha"
                        onChange={(e: any) => setPassword(e.target.value)}
                    />
                    <input
                        type="submit"
                        className="submit-btn btn"
                        value="Atualizar"
                        disabled={!password || !passwordConfirm}
                    />
                </form>
            </div>
        </div>
    )
}

export default Formulario